import React, { useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';

import './make-report-confirm-modal.scss';

const MakeReportConfirmModal: React.FC = () => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div className={`make-report-confirm-modal-content ${api.getDevice()}`}>
            <div className="make-report-confirm-modal-content__main">
                <p>
                    Twoje zgłoszenie zostało przyjęte.
                </p>
            </div>
        </div>
    );
};

export default MakeReportConfirmModal;
